import './App.css';
import BenefitsSection from './components/BenefitsSection/BenefitsSection';
import ExercisesSection from './components/ExercisesSection/ExercisesSection';
import FinalCta from './components/FinalCta/FinalCta';
import HeroSection from './components/HeroSection/HeroSection';
import HowItWorks from './components/HowItWorks/HowItWorks';
import SiteFooter from './components/SiteFooter/SiteFooter';
import SiteHeader from './components/SiteHeader/SiteHeader';
import LegalPage from './pages/LegalPage/LegalPage';

function App() {
  const path = window.location.pathname.replace(/\/$/, '') || '/';

  if (path === '/privacy') {
    return <LegalPage type="privacy" />;
  }

  if (path === '/terms') {
    return <LegalPage type="terms" />;
  }

  return (
    <main id="top">
      <SiteHeader />
      <HeroSection />
      <HowItWorks />
      <ExercisesSection />
      <BenefitsSection />
      <FinalCta />
      <SiteFooter />
    </main>
  );
}

export default App;
